export default "__VITE_ASSET__w1qIYqf3__"